module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-15.bdd4b329.svg";